<template>
	<div>
		<div class="navbar">
			<b-button to="/exact" :data="data" :vcleanExactCodes="vcleanExactCodes" :exactData="exactData"
				variant="outline-light">
				NOVA PESQUISA
			</b-button>
		</div>

		<!-- Cabeçalho -->
		<b-container>
			<b-row v-if="item.logoMontadora">
				<b-col cols="12">
					<b-img width="75" height="75" rounded="circle" :src="item.logoMontadora" />
				</b-col>
			</b-row>
			<b-row class="mt-4 mb-4 text-center">
				<b-col cols="12" md="4">
					<span class="title">MARCA:</span>
					<span>{{ item.marca }}</span>
				</b-col>
				<b-col cols="12" md="4">
					<span class="title">MODELO:</span>
					<span>{{ item.veiculo }}</span>
				</b-col>
				<b-col cols="12" md="4">
					<span class="title">ANO:</span>
					<span> DE {{ item.de }} {{ item.ate }}</span>
				</b-col>
			</b-row>
			<!-- Dianteira -->
			<b-row v-if="	item.imagemMotoristaDianteira ||
							item.imagemCaronaDianteira">
				<b-col cols="12">
					<span class="title mb-4 pb-4">VCLEAN EXACT DIANTEIRA:</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col v-if="item.imagemMotoristaDianteira">
					<div class="mt-4" style="background-color: #e9ecef; width: 100%">
						<p><b> QUAL O LIMPADOR EXACT PARA O MOTORISTA? </b></p>
						<b-card no-body :img-src="item.imagemMotoristaDianteira">
							<p><b v-if="item.codigoPolegadaMotorista">
									CÓDIGO DO MOTORISTA: {{ item.codigoPolegadaMotorista }}
								</b></p>
							<p><b v-if="item.codigoConectorMotCar">
									CONEXÃO DO MOTORISTA: {{ item.codigoConectorMotCar }}
								</b></p>
						</b-card>
					</div>

					<div v-if="item.descricaoLamina" class="description mb-4">
						<span>
							{{ item.descricaoLamina }}
						</span>
					</div>
				</b-col>
				<b-col v-if="item.codigoPolegadaCarona">
					<div class="mt-4" style="background-color: #e9ecef; width: 100%">
						<p><b> QUAL O LIMPADOR EXACT PARA O CARONA? </b></p>
						<b-card no-body :img-src="item.imagemCaronaDianteira">
							<p><b v-if="item.codigoPolegadaCarona">
									CÓDIGO DO CARONA: {{ item.codigoPolegadaCarona }}
								</b></p>
							<p><b v-if="item.codigoConectorMotCar">
									CONEXÃO DO CARONA: {{ item.codigoConectorMotCar }}
								</b></p>
						</b-card>
					</div>

					<div v-if="item.descricaoVeiculo" class="description mb-4">
						<span>
							{{ item.descricaoVeiculo }}
						</span>
					</div>
				</b-col>
			</b-row>
			<b-embed type="embed" v-if="item.videoAplicacaoDianteira" :src="item.videoAplicacaoDianteira" allowfullscreen />
			<!-- Traseira -->
			<b-row class="mt-4 pt-4" v-if="item.codigoCarenada || item.codigoSlim">
				<b-col cols="12">
					<span class="title">VCLEAN EXACT TRASEIRA:</span>
					<div v-if="item.descricaoGeral" class="description mt-3">
						<span>{{ item.descricaoGeral }}</span>
					</div>
				</b-col>
			</b-row>
			<!-- <b-row > -->
			<b-row v-if="item.codigoCarenada || item.codigoSlim">
				<b-col v-if="item.codigoCarenada">
					<b-card no-body :img-src="item.imagemMotoristaTraseira">
						<div class="mt-4" style="background-color: #e9ecef; width: 100%">
							<p><b> QUAL O LIMPADOR TRASEIRO EXACT PARA ESSE VEÍCULO? </b></p>
							<p><b v-if="item.codigoCarenada">
									CÓDIGO TRASEIRA: {{ item.codigoCarenada }}
								</b></p>
							<p><b v-if="item.codigoConectorTraseiro">
									CÓDIGO CONEXÃO TRASEIRA : {{ item.codigoConectorTraseiro }}
								</b></p>
						</div>

						<div v-if="item.descricaoLamina" class="description mb-4">
							<span>
								{{ item.descricaoLamina }}
							</span>
						</div>
					</b-card>
				</b-col>
				<b-col v-if="item.codigoSlim">
					<b-card no-body :img-src="item.imagemCaronaTraseira">
						<div class="mt-4" style="background-color: #e9ecef; width: 100%">
							<p><b> QUAL O LIMPADOR TRASEIRO EXACT PARA ESSE VEÍCULO?  </b></p>
							<p><b v-if="item.codigoConectorTraseiro">
									CÓDIGO TRASEIRA: {{ item.codigoSlim }}
								</b></p>
							<p><b v-if="item.codigoSlim">
									CÓDIGO CONEXÃO TRASEIRA: {{ item.codigoConectorTraseiro }}-S
								</b></p>
						</div>

						<div v-if="item.descricaoVeiculo" class="description mb-4">
							<span>
								{{ item.descricaoVeiculo }}
							</span>
						</div>
					</b-card>
				</b-col>
			</b-row>
			<b-embed type="embed" v-if="item.videoAplicacaoTraseira" :src="item.videoAplicacaoTraseira" allowfullscreen />
		</b-container>
		<div id="modal" class="modal">
			<span class="modal-close">&times;</span>
			<img class="modal-content" id="modal-image">
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProductDetail',
	props: {
		exactData: Array,
		vcleanExactCodes: Array,
		brand: String,
		model: String,
		year: String,
		data: Array,
	},

	data() {
		return {
			imgProps: {
				blank: true,
				blankColor: '#777',
				width: 50,
				height: 50
			},
			displayFront: '',
			displayYear: '',
			selected: {},
			item: {}
		};
	},

	methods: {
		normalizeYearValue(value) {
			if (value === undefined || value === null) {
				return '';
			}

			return String(value).trim().toUpperCase().replace(/^ATÉ\s+/i, '').replace(/^EM DIANTE$/i, '>');
		},

		findItem() {
			const marca = (this.exactData || []).filter((data) => data.marca === this.brand);
			const modelItems = marca.filter((item) => item.veiculo === this.model);

			if (!modelItems.length) {
				this.item = {};
				return;
			}

			if (!this.year) {
				this.item = modelItems[0];
				return;
			}

			const [from, to] = String(this.year).split('-');
			const normalizedFrom = this.normalizeYearValue(from);
			const normalizedTo = this.normalizeYearValue(to);

			const matchedItem = modelItems.find((item) => {
				const itemFrom = this.normalizeYearValue(item.de);
				const itemTo = this.normalizeYearValue(item.ate);

				if (normalizedFrom && itemFrom && normalizedFrom !== itemFrom) {
					return false;
				}

				if (!normalizedTo) {
					return true;
				}

				return itemTo === normalizedTo || itemTo === '>';
			});

			this.item = matchedItem || modelItems[0];
		}
	},

	watch: {
		exactData() {
			this.findItem();
		},
		brand() {
			this.findItem();
		},
		model() {
			this.findItem();
		},
		year() {
			this.findItem();
		}
	},

	mounted() {
		this.findItem();
	}
};
</script>

<style scoped>
input[type='text'] {
	margin-bottom: 15px;
}

.navbar {
	margin-bottom: 15px;
	background-color: #e9ecef;
	border: 1px solid #dfe4e8;
	border-radius: calc(0.25rem - 1px);
}

.title {
	font-weight: bold;
	margin-right: 5px;
}

.description {
	padding: 15px 10px;
}

.card {
	align-items: center;
	margin-top: 30px;
	padding: 10px;
}

.card-img {
	cursor: pointer;
	transition: 0.3s;
	width: 75%;
}

.card-img:hover {
	opacity: 0.8;
}

.column-header {
	width: 100%;
	font-weight: bold;
	padding: 5px 0;
	background-color: #e9ecef;
	border: 1px solid #dfe4e8;
	border-radius: calc(0.25rem - 1px);
	margin-bottom: 10px;
}

.column-header>span {
	display: block;
}

.column-header-title {
	padding-bottom: 10px;
	font-weight: bold;
}
</style> -->
